import { WIDGET_FEED_END_POINT } from 'constants'
import { getParamNameValueString } from 'utils/common'
// #todo loop on filters
// eslint-disable-next-line import/prefer-default-export
export const getFeedURLFromOptions = (options = {}) => {
  const { filters = {}, type, id } = options

  let url = WIDGET_FEED_END_POINT

  // #todo - create a util function to handle .toLowerCase() without error if param is not string
  if (type) {
    url += getParamNameValueString('type', type, url)
  }

  if (id) {
    url += getParamNameValueString('id', id, url)
  }

  const keys = Object.keys(filters)

  keys.forEach((key) => {
    if (typeof filters[key] !== 'undefined') {
      if (key === 'pcheck') {
        if (filters[key] === 'yes' || filters[key] === true) {
          url += getParamNameValueString(key, 'yes', url)
        }
      }
      if (key === 'country') {
        url += getParamNameValueString(
          key,
          filters[key].toString().toLowerCase(),
          url
        )
      } else {
        url += getParamNameValueString(
          key.toString().toLowerCase(),
          filters[key],
          url
        )
      }
    }
  })

  return url
}

// // sample url for jarvis
// // ?type=category_list&filters=website-toi,platform-web,pagename-articleshow
